/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TeamUserRoleType = {
    Agent: 'Agent',
    Manager: 'Manager'
} as const;
export type TeamUserRoleType = typeof TeamUserRoleType[keyof typeof TeamUserRoleType];


export function TeamUserRoleTypeFromJSON(json: any): TeamUserRoleType {
    return TeamUserRoleTypeFromJSONTyped(json, false);
}

export function TeamUserRoleTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamUserRoleType {
    return json as TeamUserRoleType;
}

export function TeamUserRoleTypeToJSON(value?: TeamUserRoleType | null): any {
    return value as any;
}

